import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { HttpActions } from "@webapp/core/abstracts/enums/http-actions.enum";
import { ApiVersionModel } from "@webapp/core/abstracts/models/api-version.model";
import { BaseApiService } from "@webapp/core/abstracts/services/base-api.service";
import { APP_CONFIG, IAppConfig } from "@webapp/core/app-config/models/app-config.models";
import { KpiStatistics, KpiStatisticsDTO } from "../kpi-statistics.models";
import { KpiStatisticsState } from "./kpi-statistics-state.service";

@Injectable()
export class KpiStatisticsApiService extends BaseApiService<KpiStatistics, KpiStatisticsDTO, KpiStatisticsState> {
  constructor(httpClient: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, state: KpiStatisticsState) {
    super("kpis", { ...new ApiVersionModel("v1") }, httpClient, appConfig, state);
  }

  public getStatisticsForKpiEndpoint(kpiId: string): string {
    return `${this.getBasePath(HttpActions.get)}/${kpiId}/statistics`;
  }
}
